export default function fullnameInitials(
  fullname: string | null | undefined,
): string {
  if (!fullname) return 'U';
  const names = fullname.trim().split(' ');
  let initials = '';
  names.forEach((item) => {
    const temp = item.split('');
    initials += temp.shift();
  });
  return initials;
}
